/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Paper, FormControl, TextField, Button, InputLabel, Select, MenuItem,
} from '@material-ui/core';
import { DashboardUserValidationSchema } from '../utils/util';
import Drawer from './Drawer';
import Actions from '../actions';
import { ROLES } from '../utils/constants';
import Loading from './Loading';

class DashboardUserForm extends Component {
    // eslint-disable-next-line react/state-in-constructor
    state={
      email: '',
      name: '',
      password: '',
      role: '',
      snack: {
        open: false,
        type: 'success',
        msg: '',
      },
      loading: false,
    };

    closeSnack = () => { return this.setState({ ...this.state, snack: { ...this.state.snack, open: false } }); };

    formupdated = (e) => {
      e.preventDefault();
      // eslint-disable-next-line react/no-access-state-in-setstate
      this.setState({ ...this.state, [e.target.name]: e.target.value });
    }

    formSubmitted = (e) => {
      e.preventDefault();
      DashboardUserValidationSchema.validate(this.state)
        .then(() => {
          this.setState({ ...this.state, loading: true });
          return this.props.addDashboardUser(this.state)
            .then(() => {
              // alert(`Dashboard User  Added Successfully!! \n Data: ${JSON.stringify(this.state)}`);
              this.setState({ ...this.state, loading: false, snack: { open: true, type: 'success', msg: 'Dashboard User  Added Successfully!!' } });
              this.resetState();
            }).catch((err) => {
              this.setState({ ...this.state, loading: false, snack: { open: true, type: 'error', msg: err.message } });
              this.resetState();
            });
        })
        .catch((err) => { return this.setState({ ...this.state, loading: false, snack: { open: true, type: 'error', msg: err.message } }); });
    }

    resetState() {
      this.setState({
        email: '',
        name: '',
        password: '',
        role: '',
      });
    }

    render() {
      return (
        <Drawer>
          <Loading
            loading={this.state.loading}
            onClose={this.closeSnack}
            snack={this.state.snack}
          />
          <Paper style={{ width: '500px', padding: '50px', marginTop: 20 }}>
            <h3 style={{ marginTop: 0 }}>Add Dashboard User</h3>
            <form className="form" onSubmit={this.formSubmitted} autoComplete="off">
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <TextField id="email" name="email" label="Email" value={this.state.email} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <TextField id="name" name="name" label="Name" value={this.state.name} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <TextField
                  label="Password"
                  type="password"
                  id="password"
                  name="password"
                  value={this.state.password}
                  onChange={(e) => { this.formupdated(e); }}
                />
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <InputLabel id="simple-select-active-label">Role</InputLabel>
                <Select
                  labelId="simple-select-active-label"
                  id="simple-select-active"
                  value={this.state.role}
                  name="role"
                  onChange={(e) => { return this.formupdated(e); }}
                  style={{ textAlign: 'left' }}
                >
                  {Object.keys(ROLES).map((role) => {
                    return (
                      <MenuItem value={ROLES[role]} key={role}>
                        {role}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '50px' }}>
                <Button variant="contained" type="submit" color="primary">Add Slot</Button>
              </FormControl>
            </form>
          </Paper>
        </Drawer>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default withRouter(connect(null, mapDispatchToProps)(DashboardUserForm));
